import React, { useState } from "react";
import { Box, IconButton, Input } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { config } from "../App";

const SearchBar = ({ searchSetFilter }) => {
  const [debounceTimeout, setdebounceTimeout] = useState(null);

  const performSearch = async (text) => {
    try {
      const response = await axios.get(`${config.endpoint}/videos?title=${text}`);
      searchSetFilter(response.data.videos);
    } catch (error) {
      if (error.response.status === 404) {
        console.log(error.response.status);
      } else {
        console.log("error");
      }
    }
  };

  const debounceSearch = (event, debounceTimeout) => {
    if (debounceTimeout) clearTimeout(debounceTimeout);
    let searchdebounce = setTimeout(() => {
      performSearch(event);
    }, 500);
    setdebounceTimeout(searchdebounce);
  };

  return (
    <Box
      display="flex"
      direction="row"
      justifyContent="center"
      alignItems="center"
      component="form"
      sx={{
        border: "1px solid #444D56",
        pl: 2,
        boxShadow: "none",
        mr: { sm: 5 },
        bgcolor: "#121212",
        width: {
          xs: 100,
          sm: 200,
          md: 300,
          lg: 400,
          xl: 500,
        },
      }}
    >
      <Input
        className="search-bar"
        placeholder="Search"
        onChange={(e) => debounceSearch(e.target.value, debounceTimeout)}
        sx={{
          color: "white",
          bgcolor: "#121212",
          border: "none",
          width: {
            xs: 100,
            sm: 200,
            md: 300,
            lg: 400,
            xl: 500,
          },
        }}
      />
      <IconButton
        type="submit"
        sx={{ p: "5px", color: "white", bgcolor: "#313131", borderRadius: "0", borderLeft: "1px solid #444D56"}}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
    </Box>
  );
};

export default SearchBar;
